<template>
  <div
    class="TransactionList">
      <v-overlay :value="overlay.flag">
        <v-progress-circular
          :rotate="-90"
          :size="100"
          :width="15"
          :value="overlay.value"
          color="primary"
        >
        {{ overlay.value }}
        </v-progress-circular>
      </v-overlay>
    <TransactionCriteria
      :baseCrudKey="baseCrudKey"
      @loadCRUDList="handleLoadCRUDList"
    />
    <CRUDList
      ref="crudList"
      :canAdd="true"
      :canEdit="true"
      :canApply="true"
      :canSave="false"
      :headers="headers"
      :showDate="true"
      :showTotal="true"
      :showExpand="true"
      :showSelect="true"
      :dataMapper="dataMapper"
      :baseCrudKey="baseCrudKey"
      :createNewItem="newItemDialog"
      :selectedItems="selectedItems"
      :itemTotal="selectedItemsAmount"
      :defaultSortBy="sortBy"
      :uploadFileParams="uploadFileParams"
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
      overrideApplyBtnLabel="SAVE"
      toolbarTitle=""
      @loadCRUDList="handleLoadCRUDList"
      @upsertItem="upsrtTransaction"
      @deleteItem="deleteTransaction"
      @emitSelectedItem="emitSelectedItem"
      @activateItem="activateTransaction"
    >
      <template v-slot:[`editedItem`]="{}">
        <TransactionEditedItem
        :baseCrudKey="baseCrudKey"
        :attachmentConstants="attachmentConstants"
        :cmnEnums="cmnEnums"
        @showOnClickApportionLikeTax="showOnClickApportionLikeTax"
        @showOnClickSpecialApportionment="showOnClickSpecialApportionment"
        @emitEditBatchPaymntItem="handleBatchPaymntDetailsEditItem"
        @editItem="editItem"
        @voidTransactionOnSave="onVoidTransactionOnSave"
        @payrixSuccess="handlePayrixSuccess"
        />
      </template>
      <template v-slot:[`additionalActions`]="{}">
          <v-row>
          <v-btn id="miscTransPrintFormatBtn"
            class="misc-trans-print-format-btn"
            text color="blue darken-1"
            @click="printReceiptFromDialogBox('receiptFormat2')">
          Print Receipt</v-btn>
          <v-btn id="miscTransPrintEONFormatBtn"
            class="misc-trans-print-format-btn"
            text color="blue darken-1"
            v-if="showTaxReceipt === false"
            @click="printReceiptFromDialogBox('printEON')">
            Print EON/App</v-btn>
            <v-btn
            class="misc-trans-tax-summary-print-btn"
            text color="blue darken-1"
            v-if="showTaxReceipt === true"
            @click="printTaxFundSummary()">
              Tax - Print Summary</v-btn>
          <v-btn id="miscTransPrint220"
            class="misc-trans-print-220-btn"
            text color="blue darken-1"
            v-if="showSpecialApportionment === true"
            @click="printReceiptFromDialogBox('printForm220')">
          Print Form 220</v-btn>
        </v-row>
        <AuditDialog id="miscTransAuditDialog"
          v-if="getActiveTransID"
          :identifier="getActiveTransID"
          activatorCaption="Audit History"
        />
        <UploadFile id="miscTransUploadFile"
          class="misctrans uploadFile"
          :bucketName="attachmentConstants.bucketName"
          :program="attachmentConstants.program"
          :parentObjectType="attachmentConstants.parentObjectType"
          :parentObjectId="getActiveTransID || ''"
          :itemIsSaved="!isNewItem"
        ><template v-slot:activator="{ activatorProps }">
        <v-btn
          color="primary"
          text
          @contextmenu.prevent="imagesRightClick(activatorProps.rightClick)"
          @click="imagesLeftClick(activatorProps.leftClick)"
        >
        {{activatorProps.caption}}
        </v-btn>
        </template>
       </UploadFile>
      </template>

      <template v-slot:[`selectDate`]="{}">
        <v-text-field class="mt-6 shrink misc-trans-select-date-to-mark-text"
          v-model="markingDateForItems"
          label="Select Date to Mark"
          type="date"
        ></v-text-field>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
      </template>
      <template v-slot:[`duplicateMarking`]="{}">
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }"
          >
            <v-icon
              class="mx-2 misc-trans-duplicate-content-icon" color="primary"
              fab icon small
              v-bind="attrs"
              v-on="on"
              :disabled="(selectedItems || []).length === 0"
              @click="miscDuplicateTransDailogBox"
            >
              {{icons.mdiContentDuplicate}}
            </v-icon>
          </template>
            <span>Duplicate</span>
        </v-tooltip>
      </div>
      <v-divider
          class="mx-4" inset vertical
        ></v-divider>
      </template>
      <template v-slot:[`canDeleteSlot`]="{}"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mx-2 misc-trans-selected-delete-icon" color="primary"
              fab icon small
              v-bind="attrs"
              v-on="on"
              :disabled="(selectedItems || []).length === 0"
              @click="deleteItems"
            >
              {{icons.mdiDelete}}
            </v-icon>
          </template>
            <span>Delete</span>
        </v-tooltip>
         <v-divider
          class="mx-4" inset vertical
        ></v-divider>
      </template>
      <template v-slot:[`additionalToolsAtRight`]="{}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="misc-trans-print-receipt-format-btn"
            depressed
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="printReceiptOutsideDialogBox('receiptFormat2')"
          >
            <v-icon left>
              {{ icons.mdiPrinter }}
            </v-icon>
            Receipt
          </v-btn>
          </template>
            <span>Print Receipt</span>
        </v-tooltip>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              small
              color="primary"
              class="ma-2 misc-trans-print-receipt-EON-btn"
              v-bind="attrs"
              v-on="on"
              @click="printReceiptOutsideDialogBox('printEON')">
              <v-icon left>
                {{ icons.mdiPrinter }}
              </v-icon>
              EON
            </v-btn>
         </template>
            <span>Print EON/App</span>
        </v-tooltip>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              small
              color="primary"
              class="ma-2 misc-trans-print-collection-summary"
              v-bind="attrs"
              v-on="on"
              :disabled="isdisabled"
              @click="printTaxFundSummaryFromList()">
              <v-icon left>
                {{ icons.mdiPrinter }}
              </v-icon>
              CS
            </v-btn>
          </template>
            <span>Print Collection Summary & Apportionment</span>
        </v-tooltip>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              small
              color="primary"
              class="ma-2 misc-trans-print-form220"
              v-bind="attrs"
              v-on="on"
              :disabled="specialApportionmentBtnValidation"
              @click="printReceiptOutsideDialogBox('printForm220')">
              <v-icon left>
                {{ icons.mdiPrinter }}
              </v-icon>
              Form 220
            </v-btn>
          </template>
            <span>Print Form 220</span>
        </v-tooltip>
      </template>
       <template v-slot:[`bulkMarking`]="{}"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on,attrs }">
            <transactionNumber
              v-if="forceReloadDetails"
              :cmnBaseCrudKey="baseCrudKey"
              :closeDialogBox="closeDialogBox"
              :criteriaStateFY="criteriaState.fiscalYear"
              :selectedItemsAmount="selectedItemsAmount"
              :selectedItems="selectedItems"
              :cmnEnums="cmnEnums"
              :isNewItem="isNewBatchPaymentTransaction"
              :batchPaymentDetailsEditItem="transNoObject"
              :programType="'MISC'"
              @settingDialogVal="settingDialogVal"
              @transactionNumberObj="transactionNumberObj"
              @deleteBatchPaymentDetails="deleteBatchPaymentDetails"
              />
            <v-btn v-bind="attrs" v-on="on"
            class="mx-2" color="primary"
            fab icon small
            :disabled="(selectedItems || []).length === 0"
            @click="openComponent"
            >
              <v-icon>
                {{icons.mdiAlphaBCircle}}
              </v-icon>
            </v-btn>
          </template>
           <span>Batch Pay</span>
        </v-tooltip>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
      </template>
      <template v-slot:[`additionalActionsAfterSave`]="{}">
        <v-btn
          id="miscTransSaveAndPrintBtn"
          class="misc-trans-print-format-btn"
          text color="blue darken-1"
          @click="saveAndPrint"
          >SAVE & PRINT</v-btn>
      </template>
    </CRUDList>
    <v-dialog
      v-model="miscTransAdditionalDialogBox"
      persistent
      width="60vw"
      height="145vh">
    <v-card>
      <v-card-title>
        <span class="headline"> {{ this.miscTransAdditionalDialog.headerText }}</span>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary"
          text @click="miscTransAdditionalDialogAction(true)">
           {{ this.miscTransAdditionalDialog.btnOneText }}
        </v-btn>
        <v-btn color="primary"
          text @click="miscTransAdditionalDialogAction(false)">
          {{ this.miscTransAdditionalDialog.btnTwoText }}
        </v-btn>
        <v-btn v-if="miscTransAdditionalDialog.showCancelBtn"
          color="primary" text
          @click="miscTransAdditionalDialogAction(null)">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
    <CRUDDialog baseCrudKey="miscVoidAuditRecord" :canCancel="false"
      @upsertItem="upsertAuditTransactionForVoids">
      <template v-slot:[`editedItem`]="{}">
        <auditRecord baseCrudKey="miscVoidAuditRecord" />
      </template>
    </CRUDDialog>
  </div>
</template>

<script>
import {
  mdiAlphaBCircle,
  mdiContentDuplicate,
  mdiDelete,
  mdiPrinter,
} from '@mdi/js';
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import { clients } from '../../../util/clients';
import { authRoles } from '../../../router/roleGroups';
import { isAuthorised } from '../../../store/auth/token';
import { printerHandler } from '../../../util/pdf-to-printer.util';
import {
  calculateFiscalYears,
  getBusinessDateForPaymentEntry,
  toFiscalYear,
  toIsoDate,
  toShortDate,
  updateDateFormat,
} from '../../../util/shared/tmc-global';
import {
  amountRoundOfToClosestDecimal,
  amountToNumber,
  defaultGridLoading,
  defaultOverlayConfig,
  extractId,
  isAltR,
  isEmptyObject,
  manageGridLoading,
} from '../../../util/shared/vue-global';
import { getWorkstationNumber } from '../../../util/workstation-util';
import AuditDialog from '../../common/audit/AuditDialog.vue';
import CRUDDialog from '../../common/base/crud/CRUDDialog.vue';
import CRUDList from '../../common/base/crud/CRUDList.vue';
import auditRecord from '../../tax/payments/audit/auditRecord.vue';
import { generateQueryString } from '../../common/base/report/report-util';
import transactionNumber from '../../common/transactionNumber/transactionNumber.vue';
import UploadFile from '../../common/UploadFile.vue';
import { updateDescription } from '../../Mtg/Transaction/MtgTransactionHelper';
import {
  buildPaymentItem, checkTransactionDetails, determineCssProps, firstAltKeyRuleFailure, isPastFiscalYear,
} from './miscTransaction.util';
import MiscTransactionList from './MiscTransactionList.mixin';
import TransactionCriteria from './TransactionCriteria.vue';
import TransactionEditedItem from './TransactionEditedItem.vue';

const { backendRest } = clients.direct;
const bankCrudKey = 'sharedBank';
// Maps the receipt type this screen prints to the printer/tray row the county
// toolkit configures for it. EON/App is its own document with its own row
// (Washington); Form 220 has none yet, so it stays on the preview. Add a key
// here when it gets one.
const printerReportNames = { receiptFormat2: 'miscReceipts', printEON: 'miscEonApp' };

const getHeaders = () => {
  const headers = [
    {
      text: 'Attachments', value: 'hasFiles', sortable: false, formatter: 'file',
    },
    {
      text: 'Date', value: 'businessDate', width: '10%', formatter: 'shortDate',
    },
    { text: 'Rec#', value: 'receiptNumber' },
    { text: 'Wkst', value: 'wkst' },
    {
      text: 'Amount', value: 'amount', formatter: 'amount', align: 'right',
    },
    { text: 'Received Of', value: 'whomStr' },
    { text: 'Description', value: 'shortDesc' },
    { text: '', value: 'data-table-expand' },
  ];
  return headers;
};

const postProcessMisc = (miscTransactions, miscSettings) => {
  const buildPostProcessData = (transaction) => ({
    ...transaction,
  });

  let processedData;
  if (Array.isArray(miscTransactions)) {
    processedData = miscTransactions.map((transaction) => {
      const updatedTransaction = { ...transaction };
      updatedTransaction.crudRowCssAppend = determineCssProps(updatedTransaction, miscSettings);
      return buildPostProcessData(updatedTransaction);
    });
  } else {
    const updatedTransaction = { ...miscTransactions };
    updatedTransaction.crudRowCssAppend = determineCssProps(updatedTransaction, miscSettings);
    processedData = buildPostProcessData(updatedTransaction);
  }
  return processedData;
};

export default {
  mixins: [MiscTransactionList],
  data: () => ({
    baseCrudKey: 'miscTransaction',
    headers: [],
    dateForCriteria: ['fromBusinessDate', 'toBusinessDate'],
    miscDetailsElements: ['fund', 'source', 'unit', 'taxDistrict'],
    markingDateForItems: undefined,
    activeTransItem: undefined,
    transNoObject: {},
    activeEditedItem: {},
    showTaxReceipt: false,
    closeDialogBox: false,
    closeCSCDialogBox: false,
    forceReloadDetails: false,
    showSpecialApportionment: false,
    overlay: defaultOverlayConfig(),
    attachmentConstants: {
      bucketName: 'misc',
      program: 'misc',
      parentObjectType: 'miscTransaction',
    },
    uploadFileParams: {
      bucketName: 'misc',
      program: 'misc',
      parentObjectType: 'miscTransaction',
    },
    uploadFileClickParams: {
      leftClickFlag: false,
      leftClickDef: undefined,
      rightClickFlag: false,
      rightClickDef: undefined,
    },
    miscTransAdditionalDialogBox: false,
    miscTransAdditionalDialog: {
      headerText: '',
      dialogBoxType: '',
      btnOneText: 'YES',
      btnTwoText: 'NO',
      isCopyAmount: false,
      showCancelBtn: false,
    },
    icons: {
      mdiContentDuplicate,
      mdiAlphaBCircle,
      mdiDelete,
      mdiPrinter,
    },
    sortBy: [
      {
        column: 'businessDate',
        direction: 'desc',
      },
      {
        column: 'receiptNumber',
        direction: 'desc',
      },
    ],
    isNewBatchPaymentTransaction: false,
    gridLoading: defaultGridLoading(),
    shouldOpenVoidAuditSummary: false,
    reasonCodeForDescription: '',
  }),
  created() {
    window.addEventListener('keydown', this.shortcutHandler);
    this.headers = getHeaders();
    this.initCriteria();
    this.criteriaState = updateDateFormat(this.criteriaState, this.dateForCriteria);
    this.initializeMiscFiscalYears();
    this.markingDateForItems = this.todaysDate; // by default
    this.loadConfig({ requiredScope: 'miscConfig' });
    this.loadConfig({ requiredScope: 'global' });
  },
  destroyed() {
    window.removeEventListener('keydown', this.shortcutHandler);
  },
  components: {
    CRUDList,
    TransactionCriteria,
    TransactionEditedItem,
    transactionNumber,
    AuditDialog,
    CRUDDialog,
    UploadFile,
    auditRecord,
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'index',
      'item',
      'items',
    ]),
    ...mapGetters(['todaysDate']),
    ...mapGetters('auth/token', ['authUser']),
    ...mapState({
      miscRegYears: (state) => state.misc.miscTransaction.regYears,
      storedSelectedItems: (state) => state.misc.miscTransaction.selectedItems,
      nextReceiptNumber: (state) => state.misc.miscTransaction.nextReceiptNumber,
      businessDateRange: (state) => state.misc.miscTransaction.businessDateRange,
      nextTransNumber: (state) => state.common.cmnTransNumber.nextTransNumber,
      miscSettingItem: (state) => state.SystemConfig.miscSettingItem,
      apportionmentSettingItem: (state) => state.SystemConfig.apportionmentSettingItem || {},
      devSetting: (state) => state.SystemConfig.devSettingItem || {},
      cmnEnums(state) {
        return this.mapBankToPaymentType(state.enums);
      },
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    selectedItems: {
      get() {
        return this.storedSelectedItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    fiscalYearList() {
      const registerdYears = (this.miscRegYears || {});
      const allowAll = true;
      return calculateFiscalYears(registerdYears, allowAll);
    },
    specialApportionmentBtnValidation() {
      if ((this.selectedItems || []).length === 1) {
        const isTransSpecialApporitonment = this.selectedItems[0].isSpecialApportionment;
        return !isTransSpecialApporitonment;
      }
      return true;
    },
    isdisabled() {
      return this.selectedItems.length > 1 || !this.selectedItems.some((t) => t.isApportionLikeTax);
    },
    getActiveTransID() {
      return this.activeTransItem && this.activeTransItem._id;
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    selectedItemsAmount() {
      const amountSum = (this.selectedItems || []).reduce((acc, obj) => acc
        + amountToNumber(obj.amount), 0);
      return amountSum;
    },
  },
  methods: {
    manageGridLoading,
    ...mapActions(['reAuth', 'flashError', 'flashWarn']),
    ...mapActions('SystemConfig', ['loadConfig']),
    ...mapActions('misc/miscTransaction', [
      'loadMiscTransaction',
      'upsertMiscTrans',
      'loadFiscalRegYears',
      'loadLastReceiptNo',
      'loadLastTransactionNo',
      'deleteMiscTransaction',
      'loadBusinessDateRange',
    ]),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    ...mapActions('shared/source', [
      'loadCmnSource',
    ]),
    ...mapActions('misc/schoolUnit', [
      'loadMiscUnitCode',
    ]),
    ...mapActions('common/cmnWhom', [
      'loadCmnWhom',
    ]),
    ...mapActions('shared/taxDistrict', [
      'loadTaxDistrict',
    ]),
    ...mapActions('tax/taxPayment', [
      'upsertTaxPaymentAudits',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
      'setItem',
      'setIndex',
      'setIsVisible',
    ]),
    ...mapMutations('files', [
      'setFiles',
    ]),
    ...mapMutations('misc/miscTransaction', [
      'setSelectedItems',
      'setReceiptPulse',
      'setReceiptPolling',
    ]),
    ...mapMutations('common/cmnTransNumber', [
      'setTransNoPolling',
      'setTransNoPulse',
    ]),
    handlePayrixSuccess() {
      const crudDialog = this.$refs.crudList && this.$refs.crudList.$refs.crudDialog;
      if (crudDialog) {
        crudDialog.apply();
      }
    },
    handleLoadCRUDList(criteriaArgs = {}) {
      const { baseCrudKey } = this;
      const criteria = this.updateCriteriaForReq();
      // eslint-disable-next-line max-len
      // fiscalYear '0' means all-year & 'null' is a default value, don't call api if not a valid FY value
      if (criteria.fiscalYear !== 0 && !Number(criteria.fiscalYear)) return;
      manageGridLoading(this, true, 'Searching...');
      const miscSettings = this.miscSettingItem;
      this.loadMiscTransaction({
        criteria,
        baseCrudKey,
        criteriaArgs,
        postProcessTransaction: (data) => postProcessMisc(data, miscSettings),
      }).then(() => {
        this.setDefaultSelectedItems(criteriaArgs);
      }).catch((e) => {
        console.warn(e);
        this.setDefaultSelectedItems(criteriaArgs);
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    initCriteria() {
      // reset criteria while merge flag is true
      this.criteriaState = {};
      // 'null' keeping a string value so can put the `Number()` logic
      this.criteriaState.fiscalYear = 'null';
    },
    handleBatchPaymntDetailsEditItem(item) {
      this.transNoObject = JSON.parse(JSON.stringify(item));
      this.isNewBatchPaymentTransaction = false;
      this.closeDialogBox = true;
      this.forceReloadDetails = true;
      return this.transNoObject;
    },
    async initializeMiscFiscalYears() {
      await this.loadFiscalRegYears({ baseCrudKey: this.baseCrudKey });
      const regYears = this.fiscalYearList || [];
      if ((regYears || []).length > 0) {
        this.criteriaState.fiscalYear = (regYears[regYears.length - 1] || {}).year;
      }
      this.handleLoadCRUDList();
      this.loadLists(this.criteriaState.fiscalYear);
    },
    async upsrtTransaction(item, closeDialog = true) {
      // A new receipt can't go into a fiscal year that has already ended. Misc admins may,
      // after a warning; the backend enforces the same rule.
      if (this.isNewItem && isPastFiscalYear(item.fiscalYear, this.todaysDate)) {
        const canOverride = isAuthorised(['MiscAdministration', ...authRoles.SuperAdmin]);
        if (!canOverride) {
          this.flashError(`Fiscal year ${item.fiscalYear} has ended. You cannot create a receipt in a past fiscal year.`);
          return {};
        }
        if (!window.confirm(`WARNING! Fiscal year ${item.fiscalYear} has already ended.

Do you really want to create a receipt in a past fiscal year?`)) {
          return null;
        }
      }
      /* For new item check wkst, and if it is not avaible exit early with message */
      if (this.isNewItem && !item.wkst) {
        this.flashError('Error: While upserting receipt, workstation number not exist!');
        return {};
      }

      // handle warning for mismatched amounts and missing required fields
      const {
        allDetailsHaveReqdFields,
        isPaidInFull,
        isDetailAmtMatched,
      } = checkTransactionDetails(item);

      if (!item.isCorrection && (!isPaidInFull || !isDetailAmtMatched || !allDetailsHaveReqdFields)) {
        const proceed = window.confirm('PLEASE NOTE! This record either\n\n(1) Contains empty field entries for Receipt Details and/or Payment Details\nOR\n(2) Has a mismatched Reconciliation or Payment Amount\n\nDo you wish to proceed?');
        if (!proceed) {
          return null;
        }
      }

      // Gate the save on the same unit/source/fund alt-key rule MiscDetails.vue shows
      // inline, so a bad line is warned about and kept open instead of closing the
      // dialog and letting the backend reject the receipt after the fact.
      const altKeyRuleFailureMessage = firstAltKeyRuleFailure(item.details, {
        sources: this.items('sharedSource'),
        funds: this.items('sharedFund'),
        unitCodes: this.items('miscUnitCode'),
        taxUnits: this.items('miscTransTaxUnit'),
        useNewUnitCodeSetup: (this.miscSettingItem || {}).useNewUnitCodeSetup,
        isVoid: item.isVoid,
        isApportionLikeTax: item.isApportionLikeTax,
        allowFundExceptions: this.apportionmentSettingItem.allowExceptionsOnSpecialUnitCodeMiscReceipts,
        allowUnitCodeOnAPageItems: this.apportionmentSettingItem.allowUnitCodeOnAPageItems,
      });
      if (altKeyRuleFailureMessage) {
        this.flashWarn(altKeyRuleFailureMessage);
        return null;
      }

      const { baseCrudKey } = this;
      const updatedItem = this.deleteFieldsNotRequireToUpsert(item);
      const shouldOpenVoidAuditSummary = this.shouldOpenVoidAuditSummary && !!updatedItem.isVoid;
      updatedItem.amount = amountToNumber(updatedItem.amount);
      if (updatedItem.bank) {
        updatedItem.bank = extractId(updatedItem.bank);
      }
      if (!updatedItem.isApportionLikeTax) {
        updatedItem.taxYear = null;
      }

      if ((updatedItem.details || []).length > 0) {
        const newDetails = [];
        for (let i = 0; i < updatedItem.details.length; i += 1) {
          const element = updatedItem.details[i];
          const amount = amountToNumber(element.amount);
          const detailItem = { ...element };
          if (updatedItem.isApportionLikeTax) {
            detailItem.fund = null;
            detailItem.unit = null;
          }
          if (!updatedItem.isApportionLikeTax) {
            detailItem.taxDistrict = null;
          }
          if (detailItem.fund) {
            detailItem.fund = extractId(detailItem.fund);
          }
          if (detailItem.source) {
            detailItem.source = extractId(detailItem.source);
          }
          if ((this.miscSettingItem || {}).useNewUnitCodeSetup) {
            detailItem.unit = extractId(detailItem.unit);
          } else if (detailItem.unit) {
            detailItem.unit = extractId(detailItem.unit);
          }
          if (detailItem.taxDistrict) {
            detailItem.taxDistrict = extractId(detailItem.taxDistrict);
          }
          if (updatedItem.isCalculatePercentage) {
            detailItem.percentageBreakdown = amountRoundOfToClosestDecimal(
              detailItem.percentageBreakdown, 5,
            );
          } else {
            detailItem.percentageBreakdown = null;
          }
          // if fund and taxDistrict are empty, do not push details
          if (detailItem.fund || detailItem.taxDistrict) {
            newDetails.push({ ...detailItem, amount });
          }
        }
        updatedItem.details = newDetails;
      }

      if (updatedItem.transactionNumberObject) {
        updatedItem.transactionNumberObject = extractId(updatedItem.transactionNumberObject);
      }
      if ((updatedItem.paymentDetails || []).length > 0) {
        const newPaymentDetails = [];
        for (let i = 0; i < updatedItem.paymentDetails.length; i += 1) {
          const element = updatedItem.paymentDetails[i];
          const newUpdatedElement = buildPaymentItem(element);
          // if paymentType is empty, do not push the paymentDetails
          if (newUpdatedElement.paymentType) {
            newPaymentDetails.push({
              ...newUpdatedElement,
            });
          }
        }
        updatedItem.paymentDetails = newPaymentDetails;
      }

      /*
        Trying to reduce the chance of skipping receipt number,
        stopping polling just before upserting
      */
      this.setReceiptPolling(undefined);
      this.setTransNoPolling(undefined);
      this.reasonCodeForDescription = ''; // reset reason code for description
      const miscSettings = this.miscSettingItem;
      const response = await this.upsertMiscTrans({
        item: updatedItem,
        baseCrudKey,
        postProcessTransaction: (data) => postProcessMisc(data, miscSettings),
      });
      if (!isEmptyObject(response)) {
        // Only close once the upsert actually succeeds - closing beforehand (the old
        // behavior) discarded the user's edits whenever the backend rejected the save.
        if (closeDialog) {
          this.$refs.crudList.$refs.crudDialog.close();
        }
        this.updateActiveTransItem(response);
        if (shouldOpenVoidAuditSummary && response._id) {
          this.openVoidAuditSummaryDialog(response);
        }
      }
      this.setDefaultSelectedItems();
      return response;
    },
    loadLists(fiscalYear) {
      const currentFiscalYear = fiscalYear || toFiscalYear(new Date(this.todaysDate));
      if (currentFiscalYear !== 'null') {
        this.loadFunds({
          criteria: {
            fiscalYear: currentFiscalYear,
            sortBy: [
              {
                column: 'fund',
                direction: 'asc',
              },
            ],
          },
          baseCrudKey: 'sharedFund',
        });
        this.loadCmnSource({
          criteria: {
            fiscalYear: currentFiscalYear,
            isSkipMiscellaneousTransaction: false,
            sortBy: [
              {
                column: 'sourceSubSourceNumber',
                direction: 'asc',
              },
            ],
          },
          baseCrudKey: 'sharedSource',
        });
        this.loadMiscUnitCode({
          criteria: {
            fiscalYear: currentFiscalYear,
            sortBy: [
              {
                column: 'unitCode',
                direction: 'asc',
              },
            ],
          },
          baseCrudKey: 'miscUnitCode',
        });
        this.loadCmnWhom({
          criteria: {
            fiscalYear: currentFiscalYear,
          },
          baseCrudKey: 'miscWhom',
        });
      }
      this.loadTaxDistrict({
        criteria: {},
        baseCrudKey: 'sharedTaxDistrict',
      });
    },
    async globalPtmConfig() {
      const globalSetting = await this.loadConfig({ requiredScope: 'global' });
      const paymentSetting = await this.loadConfig({ requiredScope: 'paymentConfig' });
      return { globalSetting, paymentSetting };
    },
    async businessDateDefault() {
      let registerOverride;
      if (this.isNewItem) {
        const { globalSetting, paymentSetting } = await this.globalPtmConfig();
        const payment = (paymentSetting[0] || []).configuration || {};
        const { configuration } = (globalSetting[0] || []);
        if (configuration.miscellaneous && payment.changeBussDateIndividually) {
          registerOverride = getBusinessDateForPaymentEntry();
        } else if (configuration.miscellaneous) {
          registerOverride = configuration.businessDate;
        } else {
          registerOverride = this.todaysDate;
        }
      }
      return toIsoDate(registerOverride);
    },
    newItemDialog() {
      /*
        If you are updating this, also have a look in
        'src/components/Gl/InterestApportionment/MiscTransactionBase.vue'
      */
      this.setFiles([]);
      let newItem = {};
      newItem = {
        businessDate: this.todaysDate,
        fiscalYear: this.criteriaState.fiscalYear || toFiscalYear(new Date(this.todaysDate)),
        // by default the new item should be miscellaneous if nothing is selected in criteria
        isApportionLikeTax: false,
        receiptNumber: undefined,
        isCalculatePercentage: false,
        whomStr: '',
        description: '',
        amount: 0.00,
        specialAxGlDate: null,
        taxYear: null,
        wkst: null,
        transactionNumber: null,
        details: [{
          fund: null,
          source: null,
          unit: null,
          taxDistrict: null,
          percentageBreakdown: 0,
          amount: 0,
        }],
      };
      this.loadLastReceiptNo({ fiscalYear: newItem.fiscalYear });
      this.loadLastTransactionNo({ fiscalYear: newItem.fiscalYear });
      this.globalPtmConfig().then(({ globalSetting }) => {
        const global = ((globalSetting || [])[0] || {}).configuration || {};
        if (this.miscSettingItem && this.miscSettingItem.usedLastBusinessDate
          && global && !global.miscellaneous
        ) {
          this.loadBusinessDateRange().then(() => {
            newItem.businessDate = new Date(this.businessDateRange.max) > new Date()
              ? this.businessDateRange.max : this.todaysDate;
          }).catch((e) => {
            console.warn(e);
            newItem.businessDate = this.todaysDate;
          });
        } else {
          this.businessDateDefault().then((busDate) => {
            newItem.businessDate = busDate;
            if (newItem.isSpecialApportionment) {
              newItem.specialAxGlDate = busDate;
            }
          });
        }
      }).catch((e) => {
        console.warn(e);
      });
      if (this.criteriaState.fiscalYear) {
        if (this.criteriaState.fund && this.criteriaState.fund.length > 0) {
          newItem.details[0].fund = this.criteriaState.fund;
        }
        if (this.criteriaState.source && this.criteriaState.source.length > 0) {
          newItem.details[0].source = this.criteriaState.source;
        }
        if (this.criteriaState.unit && this.criteriaState.unit.length > 0) {
          newItem.details[0].unit = this.criteriaState.unit;
        }
        if (this.criteriaState.taxDistrict && this.criteriaState.taxDistrict.length > 0) {
          newItem.details[0].taxDistrict = this.criteriaState.taxDistrict;
        }
        if (this.miscSettingItem.cashAndCheckDepositBank) {
          newItem.bank = this.miscSettingItem.cashAndCheckDepositBank;
        }
        if (this.miscSettingItem.taxYear) {
          newItem.taxYear = this.miscSettingItem.taxYear;
        }
        if (this.miscSettingItem.defaultSpecialApportionment) {
          newItem.isSpecialApportionment = this.miscSettingItem.defaultSpecialApportionment;
          if (!newItem.specialAxGlDate) {
            newItem.specialAxGlDate = newItem.businessDate;
          }
        }
        if (this.miscSettingItem.defaultWkstNo) {
          newItem.wkst = this.miscSettingItem.defaultWkstNo;
        } else {
          newItem.wkst = getWorkstationNumber();
        }
      }
      return newItem;
    },
    updateCriteriaForReq() {
      const updatedCriteria = updateDateFormat(this.criteriaState, this.dateForCriteria);
      return updatedCriteria;
    },
    dataMapper(dataItems) {
      const listData = [];
      for (let i = 0; i < dataItems.length; i += 1) {
        listData.push(dataItems[i]);
        listData[i].shortDesc = `${(dataItems[i].description || '').substring(0, 20)}...`;
        if (Array.isArray(dataItems[i].details) && dataItems[i].details.length > 0) {
          if (dataItems[i].details.length === 1) {
            listData[i].fundNo = (dataItems[i].details[0].fund || {}).fund;
            listData[i].sourceSubSourceNumber = (dataItems[i].details[0].source || {})
              .sourceSubSourceNumber;
            listData[i].unitCodeNumber = (dataItems[i].details[0].unit || {}).unitCodeNumber;
          }
        }
      }
      return listData;
    },
    emitSelectedItem(item) {
      this.selectedItems = item;
    },
    setDefaultSelectedItems(criteriaArgs = {}) {
      if (criteriaArgs.searchMode === 'wildcard') {
        this.$nextTick(() => {
          this.selectedItems = [...this.selectedItems];
        });
      } else {
        this.$nextTick(() => {
          this.selectedItems = [];
        });
      }
    },
    buildMiscDetailsForReq(detail) {
      const miscDetail = { ...detail };
      this.miscDetailsElements.forEach((element) => {
        // #migrateUnitCode -> update if operation
        if (detail[element]) {
          if (this.miscSettingItem.useNewUnitCodeSetup && detail[element] === 'unit') {
            // don't extract ID
          } else {
            miscDetail[element] = extractId(miscDetail[element]);
          }
        }
      });
      return miscDetail;
    },
    deleteTransaction(item) {
      const { baseCrudKey } = this;
      this.deleteMiscTransaction({ item, baseCrudKey }).then(() => {
        this.setDefaultSelectedItems();
      }).catch((e) => {
        console.warn(e);
        this.setDefaultSelectedItems();
      });
    },
    async deleteItems() {
      if (window.confirm(`CAREFUL! Are you sure you want to DELETE ${this.selectedItems.length} record/s?`)) {
        for (let i = 0; i < (this.selectedItems || []).length; i += 1) {
          const item = this.selectedItems[i];
          this.deleteTransaction(item);
        }
      }
      this.selectedItems = [];
    },
    shortcutHandler(e) {
      if (isAltR(e)) {
        this.printReceiptFromDialogBox('receiptFormat2');
      }
    },
    async saveAndPrint() {
      await this.printReceiptFromDialogBox('receiptFormat2');
      this.setIsVisible([this.baseCrudKey, false]);
    },
    async printReceiptFromDialogBox(receiptName) {
      const isValidForm = this.$refs.crudList.$refs.crudDialog.validateForm();
      // if a valid new / existing transaction, save and print
      if (isValidForm) {
        const miscTransId = await this.upsertMiscData();
        if (miscTransId) {
          this.printReceipt(receiptName, miscTransId);
        }
      }
      // if an invalid existing transaction, at-least print
      if (!this.isNewItem && !isValidForm) {
        const editItemId = this.activeEditedItem._id;
        if (editItemId) {
          this.printReceipt(receiptName, editItemId);
        }
      }
    },
    async printReceiptOutsideDialogBox(receiptType) {
      const miscTransId = this.selectedItems.map((t) => t._id).join(',');
      this.printReceipt(receiptType, miscTransId);
    },
    async printReceipt(receiptType, miscTransId) {
      const { jwt } = await this.reAuth();
      const params = [
        `miscTransId=${miscTransId}`,
        `token=${jwt}`,
      ];
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      const queryString = generateQueryString(params);
      let url;
      if (receiptType === 'receiptFormat2') {
        url = `${backendRest.defaults.baseURL}/misc/miscPrintReceiptFormat2${queryString}`;
      } else if (receiptType === 'printEON') {
        url = `${backendRest.defaults.baseURL}/misc/miscPrintEON${queryString}`;
      } else if (receiptType === 'printForm220') {
        url = `${backendRest.defaults.baseURL}/misc/miscPrintForm220${queryString}`;
      }
      // window.open(url, '_blank');
      const reportName = printerReportNames[receiptType];
      printerHandler(this, { url, reportName, deafultPrinterMode: Boolean(reportName) });
    },
    activateTransaction(val) {
      this.activeTransItem = val;
    },
    async imagesLeftClick(leftClick) {
      if (this.isNewItem) {
        this.uploadFileClickParams.leftClickFlag = true;
        this.uploadFileClickParams.leftClickDef = leftClick;
        await this.upsrtTransaction(this.activeEditedItem, false);
      } else {
        leftClick();
      }
    },
    async imagesRightClick(rightClick) {
      if (this.isNewItem) {
        this.uploadFileClickParams.rightClickFlag = true;
        this.uploadFileClickParams.rightClickDef = rightClick;
        await this.upsrtTransaction(this.activeEditedItem, false);
      } else {
        rightClick();
      }
    },
    settingFields(res) {
      this.activeTransItem = res;
      this.setItem([this.baseCrudKey, res]);
      this.setIndex([this.baseCrudKey, 0]);
      this.setReceiptPolling(undefined);
      this.setTransNoPolling(undefined);
    },
    updateActiveTransItem(res) {
      if (this.uploadFileClickParams.leftClickFlag) {
        this.settingFields(res);
        this.$nextTick(() => {
          this.imagesLeftClick(this.uploadFileClickParams.leftClickDef);
          this.uploadFileClickParams.leftClickFlag = false;
          this.uploadFileClickParams.leftClickDef = undefined;
        });
      } else if (this.uploadFileClickParams.rightClickFlag) {
        this.settingFields(res);
        this.$nextTick(() => {
          this.imagesRightClick(this.uploadFileClickParams.rightClickDef);
          this.uploadFileClickParams.rightClickFlag = false;
          this.uploadFileClickParams.rightClickDef = undefined;
        });
      }
      return false;
    },
    // Selected receipts Batch Pay must refuse: any payment line (even a blank $0.00 one)
    // or an already-attached batch transaction number.
    blockedBatchPayItems() {
      return (this.selectedItems || []).filter((item) => !this.isContainingDetails(item));
    },
    openComponent() {
      const blockedItems = this.blockedBatchPayItems();
      this.isNewBatchPaymentTransaction = true;
      if (blockedItems.length === 0) {
        if (window.confirm(`Are you sure want to Batch Pay ${(this.selectedItems || []).length} record/s?`)) {
          this.closeDialogBox = true;
          this.forceReloadDetails = true;
        }
      } else {
        const receiptNumbers = blockedItems.map((item) => item.receiptNumber || '(no number)').join(', ');
        this.flashError(`Batch Pay could not start: receipt(s) ${receiptNumbers} already have payment details or a batch transaction number. Open each receipt, remove any payment lines (including blank $0.00 lines) and save, then select them again for Batch Pay.`);
        this.selectedItems = [];
      }
    },
    mapBankToPaymentType(stateArr) {
      const mtgSettingObj = { ...this.mtgSettingItem } || {};
      const bankArr = this.items(bankCrudKey) || [];
      const paymentTypeEnums = updateDescription(stateArr.mtgPaymentTypeEnum,
        mtgSettingObj, bankArr);
      const eftTypeEnums = updateDescription(stateArr.mtgEFTTypeEnum, mtgSettingObj, bankArr);
      const mtgPaymentObj = {
        cmnPaymentTypes: paymentTypeEnums,
        cmnEFTTypes: eftTypeEnums,
        cmnCardTypes: stateArr.mtgCCardTypeEnum || [],
      };
      return mtgPaymentObj;
    },
    settingDialogVal(value) {
      this.closeDialogBox = value;
      // removing from dom
      this.forceReloadDetails = false;
      this.transNoObject = {};
    },
    async transactionNumberObj(transNumObj) {
      if (this.isNewBatchPaymentTransaction) {
        this.upsertBatchPaymentDetails(transNumObj);
      } else {
        this.handleTransactionsAfterBatchPayment([], { operation: 'update' });
      }
      this.selectedItems = [];
    },
    showOnClickApportionLikeTax(value) {
      this.showTaxReceipt = value;
      return value;
    },
    showOnClickSpecialApportionment(value) {
      this.showSpecialApportionment = value;
      return value;
    },
    onVoidTransactionOnSave(value) {
      this.shouldOpenVoidAuditSummary = !!value;
    },
    openVoidAuditSummaryDialog(response) {
      this.activeTransItem = response;
      this.shouldOpenVoidAuditSummary = false;
      const voidItem = {
        reciept: String(response.receiptNumber || ''),
        businessdate: toShortDate(response.businessDate),
        workstation: Number(response.wkst) || 0,
        auditSummary: 'Miscellaneous Receipt Voided',
        auditReason: '',
        user: this.authUser,
        system: 'misc',
        approvalStatus: false,
        approvalDate: null,
        approvalUser: null,
      };
      this.setItem(['miscVoidAuditRecord', voidItem]);
      this.setIsVisible(['miscVoidAuditRecord', true]);
    },
    async upsertAuditTransactionForVoids(item) {
      const updatedItem = { ...item };
      updatedItem.businessdate = updatedItem.businessdate
        ? toIsoDate(updatedItem.businessdate) : null;
      if (!(this.miscSettingItem || {}).noAuditRecordOnVoids) {
        await this.upsertTaxPaymentAudits({
          item: [updatedItem],
        });
      }
      if (updatedItem.auditReason) {
        this.reasonCodeForDescription = updatedItem.auditReason;
        this.upsertReasonCode();
      }
    },
    upsertReasonCode() {
      if (this.reasonCodeForDescription) {
        const updatedItem = { ...this.activeTransItem };
        if (updatedItem.description) {
          updatedItem.description = `${updatedItem.description}\n${this.reasonCodeForDescription}`;
        } else {
          updatedItem.description = this.reasonCodeForDescription;
        }
        // activeTransItem carries populated refs (bank, details.fund/source, ...) straight
        // from the GraphQL response, same shape upsrtTransaction expects from the crud dialog
        // — reuse it so those refs get flattened to ids instead of duplicating that logic here.
        this.upsrtTransaction(updatedItem, false);
      }
    },
    editItem(val) {
      this.activeEditedItem = val;
    },
  },
};
</script>

<style>

</style>
